import React, { Component } from "react";
import withServices from "src/HOCs/withServices";
import Navbar from "../../../components/CustomNav/CustomNav.Component";
import { toast } from "react-toastify";
import SortableTbl from "react-sort-search-table";
import Loader from "react-loader";
import { Container } from "./TeacherList.styles";
import {Content, ContentRow } from '../../Admin/Students/StudentsList/StudentsList.styles';

interface IProps {
  services: any;
  history: any;
}

class TeacherListComponent extends Component<IProps, any> {
  public state = {
    toLogin: false,
    teachers: null,
    teachersLoaded: false,
  };
  constructor(props) {
    super(props);
  }
  public async componentDidMount() {
    const {
      services: { isUserLoggedIn, institutionsAPI, currentUserID },
    } = this.props;
    if (!isUserLoggedIn) {
      this.setState({ toLogin: true });
    } else {
      const teacherRes = await institutionsAPI.getTeachersList(currentUserID);
      if (teacherRes.ok) {
        const teachers = teacherRes.data.teachers;
        this.setState({ teachers, teachersLoaded: true });
      } else {
        toast.info("Could not complete the request at this time!");
      }
      console.log(JSON.stringify(teacherRes.data.teachers));
    }
  }
  public onLogout = () => {
    this.setState({ toLogin: true });
  };
  public toTeacherData = (props) => {
    const { history } = this.props;
    history.push(`/schools/viewteacherdata/${props.rowData.id}`);
  };
  public goBack = () => {
      const {history} = this.props;
      history.goBack();
  }
  public renderCustomTD = (props) => {
    return (
      <td>
        <button
          type="submit"
          style={{ margin: "3px" }}
          className="blue-button view-more-data table-action"
          onClick={this.toTeacherData.bind(this, props)}
        >
          View More
        </button>
      </td>
    );
  };
  public renderTeachersList = () => {
    const { teachers, teachersLoaded } = this.state;
    if (teachersLoaded) {
      return (
        <div style={{ width: "90%" }}>
          <SortableTbl
            tblData={teachers}
            tHead={[
              "ID",
              "Name",
              "0.5 Done",
              "1.0 Done",
              "Code",
              "Field 1",
              "Field 2",
              "Field 3",
              "Field 4",
              "Field 5",
              "Action",
            ]}
            dKey={[
              "id",
              "User",
              "PreAssesmentDone",
              "UpgradedPreAssesmentDone",
              "ParentStudentCode",
              "field_1",
              "field_2",
              "field_3",
              "field_4",
              "field_5",
              "viewmore",
            ]}
            customTd={[
              {
                custd: this.renderCustomTD,
                keyItem: "viewmore",
                sortable: false,
              },
            ]}
            defaultCSS={false}
          />
        </div>
      );
    } else {
      return <Loader color="#acff24" loaded={teachersLoaded}/>;
    }
  };
  public render() {
    return (
      <div>
        <Navbar logoutParent={this.onLogout} />
        <Content>
          <ContentRow className="single-col">
            <p className="go-back" onClick={this.goBack}>
              &lt; Back
            </p>
          </ContentRow>
        </Content>
        <Container>{this.renderTeachersList()}</Container>
      </div>
    );
  }
}

export default withServices(TeacherListComponent);



// WEBPACK FOOTER //
// ./src/pages/Schools/TeacherList/TeacherList.Component.tsx